import { render, staticRenderFns } from "./VesselList.vue?vue&type=template&id=24d561c8&scoped=true&"
import script from "./VesselList.vue?vue&type=script&lang=js&"
export * from "./VesselList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d561c8",
  null
  
)

export default component.exports